import ClickOutside from 'vue-click-outside';
import { WidgetInitializer } from "../functions/widget-initializer";
import { Constants } from "../functions/constants";
import { RouteUtils } from "../functions/route-utils";
import { ConfigUtils } from "../functions/config-utils";

var widgetInitializer = new WidgetInitializer(Constants.COMPONENTS.CUSTOMER_STATUS);
GlobalApp.registerInitializationHandler(Constants.COMPONENTS.CUSTOMER_STATUS, function () {
    widgetInitializer.initialize(initHeaderCustomerStatusApp);
});

function initHeaderCustomerStatusApp(element) {
    var config = ConfigUtils.getConfigFor(element);
    var vueApp = new Vue({
        el: '#' + element.id,
        data: {
            initializationReadyHook: GlobalApp.getInitializationReadyHook(),
            storeData: '',
            popupShown: false,
            searchShown: false,
            guest: true,
            customerEmail: null,
            customerDisplayName: null,
            customerAvatarImageUrl: '',
            postLogoutUrl: null,
            isPunchoutCustomer: false
        },
        directives: {
            ClickOutside
        },
        computed: {
            buttonTitle: function buttonTitle() {
                return this.guest ? 'Sign In' : 'Account';
            },
            isGuest: function isGuest() {
                return this.guest;
            }
        },
        methods: {
            init: function init() {
                var that = this;

                this.postLogoutUrl = this.getPostlogOutUrl(Constants.SIGN_OUT.BACKEND_USER_SIGN_OUT_URL);
                GlobalApp.CustomerService.getCurrentCustomer()
                    .then((data) => {
                        if (data.IsLoggedIn) {
                            that.guest = false;
                            that.customerEmail = data.Email;
                            that.customerDisplayName = data.DisplayName;
                            that.customerAvatarImageUrl = data.AvatarImageUrl;
                            if (data.BigCommerceDetails) {
                                that.postLogoutUrl = this.getPostlogOutUrl(Constants.SIGN_OUT.RDO_CUSTOMER_SIGN_OUT_URL);
                                that.isPunchoutCustomer = data.BigCommerceDetails.PunchoutEnabled?.toLowerCase() == Constants.CUSTOMER.PUNCHOUT_ENABLED_VALUE;
                            }
                            if (that.isPunchoutCustomer) {
                                let header_wrapper = document.querySelector('.header_wrapper');
                                header_wrapper.classList.add('has_punchout_header');
                            }
                        }
                    }).catch(function (err) {
                        console.warn(Constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG, err);
                    }).finally(function () {
                        that.initializationReadyHook(element.id);
                    });
            },
            togglePopupExpanded: function () {
                if (!this.popupShown) {
                    GlobalApp.EventHub.raiseEvent(Constants.EVENTS.CLOSE_ALL_POPUPS);
                    GlobalApp.EventHub.raiseEvent(Constants.EVENTS.POPUP_OPENED);
                }
                this.popupShown = !this.popupShown;
            },
            searchExpanded: function () {
                if (!this.searchShown) {
                    GlobalApp.EventHub.raiseEvent(Constants.EVENTS.CLOSE_ALL_POPUPS);
                    GlobalApp.EventHub.raiseEvent(Constants.EVENTS.POPUP_OPENED);
                }
                this.searchShown = !this.searchShown;
            },
            hidePopup: function hidePopup() {
                this.popupShown = false;
            },
            getPostlogOutUrl: function (signOutUrl) {
                let currentDomainUrl = RouteUtils.getBaseUrl();
                let logOutUri = new URL(currentDomainUrl + signOutUrl);
                var logoutPageUrl = config.logoutPageUrl == "/home" ? "/" : config.logoutPageUrl;
                logOutUri.searchParams.append(Constants.SIGN_OUT.REDIRECT_QUERY_PARAM_NAME, logoutPageUrl);

                return logOutUri.href;
            },
            bigCommerceLogout: function () {
                GlobalApp.CustomerService.logout()
                GlobalApp.MyStoreService.resetMyStorePreferences();
                window.location.href = this.postLogoutUrl;
            }
        },
        created: function () {
            this.init();
            GlobalApp.EventHub.subscribeToEvent(Constants.EVENTS.CLOSE_ALL_POPUPS, this.hidePopup);
        },
        destroyed() {
            GlobalApp.EventHub.unsubscribeToEvent(Constants.EVENTS.CLOSE_ALL_POPUPS, this.hidePopup);
        }
    });

    return vueApp.$el;
}